/**
 * TanStack Query hook for GET /api/v1/admin/security/sessions.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import api from "@/lib/api";
import type {
  ActiveSessionsListResponse,
  ActiveSessionsQuery,
} from "@/types/api";

export const ADMIN_ACTIVE_SESSIONS_KEY = [
  "admin",
  "security",
  "sessions",
] as const;

export interface UseAdminActiveSessionsArgs {
  query: ActiveSessionsQuery;
  enabled?: boolean;
}

export function useAdminActiveSessions(
  args: UseAdminActiveSessionsArgs,
): UseQueryResult<ActiveSessionsListResponse> {
  const { query, enabled = true } = args;
  return useQuery({
    queryKey: [...ADMIN_ACTIVE_SESSIONS_KEY, query],
    queryFn: async () => {
      const response = await api.get<ActiveSessionsListResponse>(
        "/admin/security/sessions",
        { params: stripEmpty(query) },
      );
      return response.data;
    },
    enabled,
  });
}

function stripEmpty(q: ActiveSessionsQuery): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(q)) {
    if (v === undefined || v === null) continue;
    if (typeof v === "string" && v.trim() === "") continue;
    out[k] = v;
  }
  return out;
}
